import React from 'react';
import {useParticipantsCategories} from './useParticipantsCategories';

export function useParticipantsFilterEnabled(eventId) {
    if (!eventId) throw new Error('eventId is required');

    const categories = useParticipantsCategories(eventId);

    return categories?.length > 0;
}
